import script from "./SalesReportNewKpis.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesReportNewKpis.vue?vue&type=script&setup=true&lang=ts"

import "./SalesReportNewKpis.vue?vue&type=style&index=0&id=7cf0f20e&lang=scss"

const __exports__ = script;

export default __exports__